export default "__VITE_ASSET__BdaMVY4P__"